import clsx from 'clsx';
import type { Control, FieldErrors, UseFormGetValues, UseFormSetValue } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import { IMaskInput } from 'react-imask';

import { autofillPhoneTransform, useAutofillDetection } from '@/hooks/useAutofillDetection';
import type { AlterPasswordlessPhoneFormData } from '@/models/login.model';

interface LoginEmailInputProps {
  control: Control<AlterPasswordlessPhoneFormData>;
  getValues: UseFormGetValues<AlterPasswordlessPhoneFormData>;
  setValue: UseFormSetValue<AlterPasswordlessPhoneFormData>;
  errors: FieldErrors<AlterPasswordlessPhoneFormData>;
}

export const LoginPhoneInput = ({ control, getValues, setValue, errors }: LoginEmailInputProps) => {
  useAutofillDetection<AlterPasswordlessPhoneFormData>(getValues, setValue, [
    {
      fieldName: 'phone',
      selector: 'input[name="phone"]',
      transform: autofillPhoneTransform,
    },
  ]);

  return (
    <>
      <Controller
        name="phone"
        control={control}
        rules={{
          required: 'Phone number is required',
          pattern: {
            value: /^\d{3}-\d{3}-\d{4}$/,
            message: 'Invalid phone number (format: xxx-xxx-xxxx)',
          },
        }}
        render={({ field: { ref, ...field } }) => (
          <IMaskInput
            data-testid="phoneInput"
            {...field}
            mask="000-000-0000"
            placeholder="Phone Number"
            // Styling taken from src/components/Input.tsx
            className={clsx(
              `text-left h-14 px-4 w-full text-base font-light bg-alter-black-4`,
              `border rounded-2xl border-solid focus:outline-none`,
              `placeholder-text-alter-black-60`
              // error ? 'border-alter-error' : 'border-alter-black-10',
            )}
            autoComplete="tel-national"
            inputRef={ref}
          />
        )}
      />
      {errors?.phone && <div className="mt-1 text-sm text-alter-error">{errors.phone.message}</div>}
    </>
  );
};
